<template lang="pug">
pr-wrapper.d-flex(fs, bg)
  pr-wrapper.preloader.align-self-center.m-auto(v-show="!airport", bg, bgo=".9")
    icon.fa-spin(:icon="'fas spinner'")
  .flight.w-100.h-100(v-show="airport")
    pr-wrapper.leftside.py-5(bg, zi="1")
      .airport-scope.overflow-hidden(
        v-nv:scope="'airport'",
        data-scroll="center",
        nv-sleep-protect,
        nv-exit-protect,
        @nv-exit="close",
        @nv-back="close",
        data-right="flight"
      )
        .scroll-container.position-relative.px-5.py-2(ref="body")
          .option(v-for="(option, index) in flight", :key="option.code")
            pr-text(weight="semibold", size="medium") {{ option.name }}
            .menu.px-3
              .menu-item(@nv-enter="choose(option.code, 'arrivals')", v-if="option.arrivals.length", v-nv="airport==option.code && type=='arrivals'")
                pr-text.background(:class="{ 'inactive-element': airport === option.code && type === 'arrivals' }") {{ $t('arrivals') }}
              .menu-item(
                @nv-enter="choose(option.code, 'departures')",
                v-if="option.departures.length",
                v-nv="airport==option.code && type=='departures'"
              )
                pr-text.background(:class="{ 'inactive-element': airport === option.code && type === 'departures' }") {{ $t('departures') }}
    pr-wrapper.rightside.py-5(bg)
      .flight-header.px-5.pb-4(ref="header")
        .d-flex.flex-column
          pr-subtitle(size="medium") {{ $t(type == "arrivals" ? 'arrivals' : 'departures') }} - ({{ airport }})
      .flight-scope.overflow-hidden(
        v-nv:scope="'flight'",
        data-scroll="center",
        nv-sleep-protect,
        nv-exit-protect,
        @nv-exit="close",
        @nv-back="close",
        data-left="airport"
      )
        .scroll-container.position-relative.px-5.py-2(ref="body")
          .option.border.d-flex.background(v-nv, v-for="(_flight_, index) in flights", :key="_flight_.code")
            .description.flex-grow-1
              pr-text.plane(ellipsis)
                pr-badge.mr-2(outline, reverse) {{ _flight_.callsign }}
                span.small {{ _flight_.airline }} - {{ _flight_.aircraft }}
              pr-text.target.font-italic.mt-1(muted, ellipsis, size="small") {{ _flight_.target }}
            .status.d-flex.align-items-center.w-25
              pr-text.alert.border.px-2.py-1.m-auto(ellipsis, size="xsmall", :class="[_flight_.color]") {{ _flight_.status }}
            .times.d-flex.align-items-center
              .departure.d-flex.align-items-center(v-if="type != 'arrivals'")
                .icon.mr-2
                  i.fal.fa-plane-departure
                .time {{ $moment.unix(_flight_.std).format("HH:mm") }}
              .arrival.d-flex.align-items-center(v-else)
                .icon.mr-2
                  i.fal.fa-plane-arrival
                .time {{ $moment.unix(_flight_.sta).format("HH:mm") }}
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "flight",
  data() {
    return {
      airport: null,
      type: null
    }
  },
  computed: {
    flights() {
      if (!this.flight || !this.airport || !this.type) return []

      const payload = this.flight.find(item => item.code === this.airport)
      return payload[this.type] || []
    },
    ...mapGetters("rss", ["flight"])
  },
  async activated() {
    await this.$store.dispatch("rss/fetchFlight")
    if (!this.flight) return this.close()

    const first = this.flight.slice(0, 1).pop()
    this.airport = first.code
    this.type = "arrivals"

    await this.$nextTick()

    _$.nav.sync("airport", true)
    _$.nav.sync("flight")
  },
  methods: {
    close() {
      __.platform.go()
    },
    async choose(code, type) {
      this.airport = code
      this.type = type

      await this.$nextTick()
      _$.nav._scopes["flight"].element.scrollTop = 0
      _$.nav.sync("flight")
    }
  }
}
</script>

<style lang="scss" scoped>
.flight {
  display: flex;

  .rightside {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: unset;
    position: relative;
    box-shadow: 5px 0 15px 2px rgba(0, 0, 0, 0.25);
    z-index: 1;
    flex-grow: 1;

    .flight-scope {
      .option {
        padding: 10px 15px;
        margin-bottom: 10px;
      }
    }
  }

  .leftside {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: unset;
    box-shadow: 5px 0 15px 2px rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 2;

    .airport-scope {
      .option {
        .menu {
          .menu-item {
            margin: 10px 0;

            .background {
              padding: 10px 15px;
            }

            &.nv-el-current {
              .background {
                border-radius: 5px;
              }
            }
            .inactive-element {
              border-radius: 5px;
              padding: 10px 15px;
            }
          }
        }
      }
    }
  }
}
</style>
